import React, { useEffect, useState } from "react";
import { getToken } from "../../services/lewooApi";
import { LEWOO_API_URL } from "../../api/lewooConfig";

const AVATAR_BG = [
  "#4c6a4f", "#5b6b3f", "#3f6b63", "#6b5b3f", "#4f5b6b", "#6b4f5b",
  "#5a6b3f", "#3f5b6b", "#6b6b4f", "#4f6b6b", "#6b4f6b", "#5b4f6b",
];

const photoCache = new Map();

function fetchPhoto(uid) {
  if (photoCache.has(uid)) return photoCache.get(uid);
  const promise = (async () => {
    try {
      const token = getToken();
      const res = await fetch(`${LEWOO_API_URL}/api/employees/${uid}/photo`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) return null;
      const ct = res.headers.get("content-type") || "";
      if (!ct.startsWith("image/")) return null;
      const blob = await res.blob();
      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  })();
  photoCache.set(uid, promise);
  return promise;
}

const getInitials = (n) => (n || "?").split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();

const EmployeeAvatar = ({ employee, emp, size = 40, fontSize, className }) => {
  const target = employee || emp || {};
  const uid = target.lewoo_uid;
  const base64 = target.image_128 ? `data:image/jpeg;base64,${target.image_128}` : null;
  const [src, setSrc] = useState(base64);

  useEffect(() => {
    if (!uid || base64 || !target.photo_path) return;
    let cancelled = false;
    fetchPhoto(uid).then((url) => {
      if (!cancelled && url) setSrc(url);
    });
    return () => { cancelled = true; };
  }, [uid, base64, target.photo_path]);

  const baseStyle = { width: size, height: size, borderRadius: "50%", objectFit: "cover", flexShrink: 0 };

  if (src) {
    return <img src={src} alt={target.name || "Employee"} className={className} style={baseStyle} onError={() => setSrc(null)} />;
  }

  const initials = getInitials(target.name);
  const color = AVATAR_BG[(Number(target.id) || 0) % AVATAR_BG.length];
  return (
    <div
      className={className}
      style={{ ...baseStyle, background: color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: fontSize || Math.round(size * 0.35), fontWeight: 600, color: "white" }}
    >
      {initials}
    </div>
  );
};

export default EmployeeAvatar;
